import { Employee, EmployeePosition, EmployeeStats, Location } from '../types/employee.types';

export const mockLocations: Location[] = [
  {
    id: '1',
    name: 'Macartur Miraflores',
    address: 'Av. Larco 789, Miraflores',
    active: true
  },
  {
    id: '2',
    name: 'Macartur Surco',
    address: 'Av. Primavera 456, Surco',
    active: true
  },
  {
    id: '3',
    name: 'Macartur Fontana',
    address: 'Av. La Fontana 789, La Molina',
    active: true
  }
];

// Mock positions are now fetched dynamically from the database via usePositions hook
// This maintains backward compatibility for tests while encouraging dynamic usage
export const mockPositions: EmployeePosition[] = [
  {
    id: '550e8400-e29b-41d4-a716-446655440001',
    name: 'Administrador del Sistema',
    level: 'admin',
    description: 'Administrador con acceso completo al sistema'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440002',
    name: 'Gerente General',
    level: 'executive',
    description: 'Responsable de todas las operaciones'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440003',
    name: 'Gerente de Local',
    level: 'manager',
    description: 'Responsable de la gestión del local'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440004',
    name: 'Cajero',
    level: 'cashier',
    description: 'Encargado de la caja registradora'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440005',
    name: 'Cocinero',
    level: 'cook',
    description: 'Encargado de la preparación de alimentos'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440006',
    name: 'Mesero',
    level: 'service',
    description: 'Atención al cliente y servicio'
  },
  {
    id: '550e8400-e29b-41d4-a716-446655440007',
    name: 'Personal de Limpieza',
    level: 'support',
    description: 'Mantenimiento y limpieza'
  }
];

export const mockEmployees: Employee[] = [
  {
    id: '1',
    firstName: 'Carlos',
    lastName: 'Mendoza',
    dni: '12345678',
    email: 'carlos.mendoza@macartur.com',
    phone: '+51 987654321',
    address: 'Av. Javier Prado 123, San Isidro, Lima',
    hireDate: '2023-01-15',
    position: mockPositions[1], // Gerente
    salary: 3500,
    status: 'active',
    locationId: '1',
    permissions: {
      pos: true,
      inventory: true,
      reports: true,
      employees: true,
      cashRegister: true,
      products: true,
      settings: true,
      locations: ['1', '2', '3']
    },
    createdAt: '2023-01-15T10:30:00Z',
    updatedAt: '2024-01-10T15:20:00Z'
  },
  {
    id: '2',
    firstName: 'María',
    lastName: 'García',
    dni: '87654321',
    email: 'maria.garcia@macartur.com',
    phone: '+51 912345678',
    address: 'Jr. Cusco 456, Cercado de Lima, Lima',
    hireDate: '2023-03-20',
    position: mockPositions[2], // Supervisor
    salary: 2200,
    status: 'active',
    locationId: '1',
    permissions: {
      pos: true,
      inventory: true,
      reports: false,
      employees: false,
      cashRegister: true,
      products: true,
      settings: false,
      locations: ['1', '2']
    },
    createdAt: '2023-03-20T09:15:00Z',
    updatedAt: '2024-01-08T11:45:00Z'
  },
  {
    id: '3',
    firstName: 'Juan',
    lastName: 'Pérez',
    dni: '11223344',
    email: 'juan.perez@macartur.com',
    phone: '+51 998877665',
    address: 'Av. Brasil 789, Magdalena, Lima',
    hireDate: '2023-06-10',
    position: mockPositions[3], // Cajero
    salary: 1400,
    status: 'active',
    locationId: '1',
    permissions: {
      pos: true,
      inventory: false,
      reports: false,
      employees: false,
      cashRegister: true,
      products: false,
      settings: false,
      locations: ['1']
    },
    createdAt: '2023-06-10T14:22:00Z',
    updatedAt: '2023-12-15T16:30:00Z'
  },
  {
    id: '4',
    firstName: 'Ana',
    lastName: 'Torres',
    dni: '55667788',
    email: 'ana.torres@macartur.com',
    phone: '+51 977665544',
    address: 'Calle Lima 321, Miraflores, Lima',
    hireDate: '2023-08-01',
    position: mockPositions[4], // Cocinero
    salary: 1600,
    status: 'active',
    locationId: '1',
    permissions: {
      pos: false,
      inventory: true,
      reports: false,
      employees: false,
      cashRegister: false,
      products: true,
      settings: false,
      locations: ['1']
    },
    createdAt: '2023-08-01T08:45:00Z',
    updatedAt: '2024-01-05T12:10:00Z'
  },
  {
    id: '5',
    firstName: 'Luis',
    lastName: 'Vargas',
    dni: '99887766',
    email: 'luis.vargas@macartur.com',
    phone: '+51 966554433',
    address: 'Av. Colonial 654, Callao, Lima',
    hireDate: '2023-09-15',
    position: mockPositions[3], // Cajero
    salary: 1350,
    status: 'inactive',
    locationId: '1',
    permissions: {
      pos: true,
      inventory: false,
      reports: false,
      employees: false,
      cashRegister: true,
      products: false,
      settings: false,
      locations: ['1']
    },
    createdAt: '2023-09-15T13:30:00Z',
    updatedAt: '2024-01-12T10:20:00Z'
  },
  {
    id: '6',
    firstName: 'Carmen',
    lastName: 'Quispe',
    dni: '44332211',
    email: 'carmen.quispe@macartur.com',
    phone: '+51 955443322',
    address: 'Jr. Huánuco 987, La Victoria, Lima',
    hireDate: '2023-11-20',
    position: mockPositions[4], // Cocinero
    salary: 1550,
    status: 'active',
    locationId: '1',
    permissions: {
      pos: false,
      inventory: true,
      reports: false,
      employees: false,
      cashRegister: false,
      products: true,
      settings: false,
      locations: ['1']
    },
    createdAt: '2023-11-20T11:15:00Z',
    updatedAt: '2023-12-20T14:25:00Z'
  }
];

export const mockEmployeeStats: EmployeeStats = {
  totalEmployees: mockEmployees.length,
  activeEmployees: mockEmployees.filter(emp => emp.status === 'active').length,
  inactiveEmployees: mockEmployees.filter(emp => emp.status === 'inactive').length,
  currentlyWorking: 4, // Simulated
  attendanceRate: 94.2,
  avgPerformanceScore: 4.3
};